// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__Nkp11","legacyBtn":"MutateMid_legacyBtn__dNMZf"};